import React from "react";
import { useTranslation } from "react-i18next";
import { INNER_FEATURES_SHAPE } from "../../lib/assets";

export const FeatureSeven = () => {
  const { t, i18n } = useTranslation();

  return (
    <section className="features-area-seven" key={i18n.language}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="features-content-seven">
              <div className="section-title-two mb-30">
                <span className="sub-title">
                  {t("aboutPage.strengthsSubTitle")}
                </span>
                <h2 className="title">{t("aboutPage.strengthsTitle")}</h2>
              </div>
              <p>{t("aboutPage.strengthsText")}</p>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="features-progress-wrap">
              <div className="progress-wrap">
                <div className="progress-item">
                  <h6 className="title">{t("aboutPage.strength1")}</h6>
                  <div
                    className="progress"
                    role="progressbar"
                    aria-label="Example with label"
                    aria-valuenow="55"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    <div
                      className="progress-bar wow slideInLeft"
                      data-wow-delay=".1s"
                      style={{
                        width: "99%",
                      }}
                    >
                      <span>99%</span>
                    </div>
                  </div>
                </div>
                <div className="progress-item">
                  <h6 className="title">{t("aboutPage.strength2")}</h6>
                  <div
                    className="progress"
                    role="progressbar"
                    aria-label="Example with label"
                    aria-valuenow="76"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    <div
                      className="progress-bar wow slideInLeft"
                      data-wow-delay=".2s"
                      style={{
                        width: "90%",
                      }}
                    >
                      <span>90%</span>
                    </div>
                  </div>
                </div>
                <div className="progress-item">
                  <h6 className="title">{t("aboutPage.strength3")}</h6>
                  <div
                    className="progress"
                    role="progressbar"
                    aria-label="Example with label"
                    aria-valuenow="90"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    <div
                      className="progress-bar wow slideInLeft"
                      data-wow-delay=".3s"
                      style={{
                        width: "90%",
                      }}
                    >
                      <span>90%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="inner-features-shape">
        <img
          src={INNER_FEATURES_SHAPE}
          alt=""
          data-aos="fade-left"
          data-aos-delay="0"
        />
      </div>
    </section>
  );
};
